import { useNavigate } from "react-router-dom";
import { X, Minus, Plus, Trash2 } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";

export function CartDrawer() {
    const { items, remove, setQty, subtotal, open, setOpen } = useCart();
    const navigate = useNavigate();

    return (
        <Sheet open={open} onOpenChange={setOpen}>
            <SheetContent side="right" className="bg-ink border-gold/15 w-full sm:max-w-md p-0 flex flex-col" data-testid="cart-drawer">
                <SheetTitle className="sr-only">Your Basket</SheetTitle>
                <div className="p-6 border-b border-gold/10 flex items-center justify-between">
                    <h2 className="font-serif text-2xl text-cream">Your Basket</h2>
                    <button onClick={() => setOpen(false)} className="text-ash hover:text-gold"><X className="w-5 h-5" /></button>
                </div>

                <div className="flex-1 overflow-y-auto p-6 space-y-5">
                    {items.length === 0 && <p className="text-ash text-center mt-16">Your basket is empty.</p>}
                    {items.map((i) => (
                        <div key={i.product_id} className="flex gap-4" data-testid={`cart-item-${i.product_id}`}>
                            <img src={i.image} alt={i.name} className="w-20 h-20 object-cover rounded-lg border border-gold/15" />
                            <div className="flex-1">
                                <p className="text-cream text-sm">{i.name}</p>
                                <p className="text-gold text-sm mt-1">${i.price.toFixed(2)}</p>
                                <div className="flex items-center gap-2 mt-2">
                                    <button onClick={() => setQty(i.product_id, i.quantity - 1)} className="w-6 h-6 rounded-full border border-gold/25 text-ash flex items-center justify-center hover:text-gold"><Minus className="w-3 h-3" /></button>
                                    <span className="text-cream text-sm w-6 text-center">{i.quantity}</span>
                                    <button onClick={() => setQty(i.product_id, i.quantity + 1)} className="w-6 h-6 rounded-full border border-gold/25 text-ash flex items-center justify-center hover:text-gold"><Plus className="w-3 h-3" /></button>
                                    <button onClick={() => remove(i.product_id)} className="ml-auto text-faded hover:text-clay"><Trash2 className="w-4 h-4" /></button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {items.length > 0 && (
                    <div className="p-6 border-t border-gold/10">
                        <div className="flex justify-between mb-4">
                            <span className="text-ash">Subtotal</span>
                            <span className="text-cream text-lg" data-testid="cart-subtotal">${subtotal.toFixed(2)}</span>
                        </div>
                        <button data-testid="cart-checkout-button" onClick={() => { setOpen(false); navigate("/checkout"); }}
                            className="w-full bg-gold text-ink rounded-full py-3 font-medium hover:bg-goldbright transition-colors active:scale-95">
                            Proceed to Checkout
                        </button>
                    </div>
                )}
            </SheetContent>
        </Sheet>
    );
}
